export default [{
	path: 'course',
	component: () => import('../../sys/teaching/course/index'),
	redirect: '/sys/course/home',
	children: [{
		path: 'type',
		component: () => import('../../sys/teaching/course/type/index'),
		meta: {
			title: '课程分类'
		}
	},
	{
		path: 'home',
		component: () => import('../../sys/teaching/course/home/index'),
		meta: {
			title: '课程管理'
		}
	},
	{
		path: 'courseManage',
		component: () => import('../../sys/teaching/course/courseManage/index'),
	}
	]
}, {
	path: '/homeDesign_webgl',
	component: () => import('../../sys/teaching/course/simexp/components/homeDesign_webgl')
}]